<mat-card appearance="outlined" *ngIf="payment_method_model.id">
  <mat-card-title>Delete {{payment_method_model.account_type === 'Checking' ? 'Bank Account' : 'Card'}}</mat-card-title>
  <div *ngIf="payment_method_model.id && payment_methods_model.length > 1">
    <mat-card-subtitle *ngIf="payment_method_model.default_account">
      Another primary payment method must be selected before you can delete this one.
    </mat-card-subtitle>
    <mat-card-actions class="mb-0">
      <button mat-raised-button class="w-75"
        [disabled]="payment_methods_model?.length === 1 || payment_method_model.default_account" (click)="unLink()"
        *ngIf="!un_link_pressed || payment_method_model.default_account">
        Delete •••• {{(payment_method_model.account_type === 'Checking' 
                        ? payment_method_model.ch_number_mask
                        : payment_method_model.cc_number_mask)?.slice(-4)}}
      </button>
      <button mat-raised-button class="w-75" (click)="confirmUnLink()" *ngIf="un_link_pressed && !payment_method_model.default_account" color="warn">
        Confirm Delete •••• {{(payment_method_model.account_type === 'Checking' 
                        ? payment_method_model.ch_number_mask
                        : payment_method_model.cc_number_mask)?.slice(-4)}}
      </button>
    </mat-card-actions>
  </div>
  <div *ngIf="payment_method_model.id && payment_methods_model.length === 1">
    <mat-card-subtitle>Add another payment account before deleting</mat-card-subtitle>
    <div class="row" id="payment-methods-wrapper">
        <div class="col-sm-6" *ngIf="regulatory_model.credit_payments_enabled">
          <a [routerLink]="['/payment-methods', 'credit', 'new']" class="payment-box">
            <div class="payment-image-wrapper">
              <div class="credit-card-image"></div>
            </div>
            <div class="payment-text-wrapper">
              <div class="payment-text">Add a <b>debit or credit card</b></div>
            </div>
          </a>
        </div>
        <div class="col-sm-6" *ngIf="regulatory_model.bank_payments_enabled">
          <a [routerLink]="['/payment-methods', 'bank', 'new']" class="payment-box">
            <div class="payment-image-wrapper">
              <div class="bank-image"></div>
            </div>
            <div class="payment-text-wrapper">
              <div class="payment-text">Add a <b>bank account</b></div>
            </div>
          </a>
        </div>
      </div>
  </div>
</mat-card>